import { render, staticRenderFns } from "./viewIntegrationData.vue?vue&type=template&id=1af613e4&scoped=true"
import script from "./viewIntegrationData.vue?vue&type=script&lang=js"
export * from "./viewIntegrationData.vue?vue&type=script&lang=js"
import style0 from "./viewIntegrationData.vue?vue&type=style&index=0&id=1af613e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af613e4",
  null
  
)

export default component.exports